import React from 'react';
import Navbar from '../../components/navbar';
import FooterAppp from '../../components/footerApp';
import LoginComponent from './LoginComponent';
const Login = () => {
  return (
    <React.Fragment>
      <Navbar isBlack={true} />
      <LoginComponent />
      <FooterAppp />
    </React.Fragment>
  );
};
export default Login;
